import type { SVGProps } from "react";

export const iconPaths = {
  layers: "M12 3 2 8l10 5 10-5-10-5zM2 13l10 5 10-5M2 18l10 5 10-5",
  map: "m3 6 6-2 6 2 6-2v14l-6 2-6-2-6 2V6zM9 4v14M15 6v14",
  search: "M11 4a7 7 0 1 0 0 14 7 7 0 0 0 0-14zm9 16-3.5-3.5",
  close: "M18 6 6 18M6 6l12 12",
  more: "M12 4.5v1M12 11.5v1M12 18.5v1",
  chevronDown: "m6 9 6 6 6-6",
  chevronUp: "m6 15 6-6 6 6",
  chevronRight: "m9 6 6 6-6 6",
  chevronLeft: "m15 6-6 6 6 6",
  check: "m5 12 5 5L20 7",
  minus: "M5 12h14",
  plus: "M12 5v14M5 12h14",
  copy: "M9 9h11v11H9zM5 15V5a2 2 0 0 1 2-2h10",
  locate: "M12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM12 2v3M12 19v3M2 12h3M19 12h3M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16z",
  fullscreen: "M4 9V4h5M15 4h5v5M20 15v5h-5M9 20H4v-5",
  exitFullscreen: "M9 4v5H4M20 9h-5V4M15 20v-5h5M4 15h5v5",
  fit: "M3 8V5a2 2 0 0 1 2-2h3M16 3h3a2 2 0 0 1 2 2v3M21 16v3a2 2 0 0 1-2 2h-3M8 21H5a2 2 0 0 1-2-2v-3M12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6z",
  ruler: "m3 17 14-14 4 4L7 21l-4-4zM7 13l2 2M10 10l2 2M13 7l2 2",
  area: "M4 6h16v12H4zM4 6l4 4M20 6l-4 4M4 18l4-4M20 18l-4-4",
  point: "M12 21s7-6.5 7-12a7 7 0 1 0-14 0c0 5.5 7 12 7 12zM12 6.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5z",
  line: "M5 17a2 2 0 1 0 0 4 2 2 0 0 0 0-4zM19 3a2 2 0 1 0 0 4 2 2 0 0 0 0-4zM6.5 17.5 17.5 6.5",
  polygon: "M12 3 21 9.5 17.5 20h-11L3 9.5 12 3z",
  undo: "M9 14 4 9l5-5M4 9h11a5 5 0 0 1 0 10h-3",
  redo: "m15 14 5-5-5-5M20 9H9a5 5 0 0 0 0 10h3",
  magnet: "M6 3v8a6 6 0 0 0 12 0V3M6 3h4v8a2 2 0 0 0 4 0V3h4M6 8h4M14 8h4",
  reverse: "M4 7h13l-3-3M20 17H7l3 3",
  simplify: "M3 17c3 0 3-10 6-10s3 10 6 10 3-10 6-10",
  merge: "M4 6h6l4 6-4 6H4M14 12h6m-3-3 3 3-3 3",
  trash: "M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3",
  play: "M7 4v16l13-8z",
  pause: "M7 4v16M17 4v16",
  info: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18zM12 8h.01M11 12h1v4h1",
  warning: "M12 3 2 20h20L12 3zM12 9v5M12 17h.01",
  error: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18zM15 9l-6 6M9 9l6 6",
  success: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18zM8 12l3 3 5-6",
  image: "M3 4h18v16H3zM9 8a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm12 8-5-5-8 8",
  eye: "M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6S2 12 2 12zM12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6z",
  eyeOff: "M3 3l18 18M10.6 10.6a2 2 0 0 0 2.8 2.8M6.6 6.6C4 8.2 2 12 2 12s3.5 6 10 6c1.7 0 3.2-.4 4.4-1M9.9 4.2C10.6 4.1 11.3 4 12 4c6.5 0 10 8 10 8s-.7 1.3-2 2.8",
  target: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16zM12 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2z",
  link: "M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1",
  legend: "M4 6h3M4 12h3M4 18h3M10 6h10M10 12h10M10 18h10",
  sun: "M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8zM12 2v2M12 20v2M2 12h2M20 12h2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4",
  moon: "M20 14.5A8 8 0 0 1 9.5 4a8 8 0 1 0 10.5 10.5z",
  monitor: "M3 4h18v12H3zM8 20h8M12 16v4",
  globe: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18zM3 12h18M12 3c3 3 3 15 0 18M12 3c-3 3-3 15 0 18",
  pin: "M12 21s7-6.5 7-12a7 7 0 1 0-14 0c0 5.5 7 12 7 12z",
  pinned: "M9 4h6l-1 6 3 3H7l3-3-1-6zM12 13v8",
  grip: "M9 5h.01M15 5h.01M9 12h.01M15 12h.01M9 19h.01M15 19h.01",
  save: "M5 3h11l3 3v15H5zM8 3v5h7V3M8 21v-7h8v7",
  external: "M14 4h6v6M20 4l-9 9M19 14v6H4V5h6",
  expandAll: "m8 5 4-4 4 4M8 19l4 4 4-4M4 12h16",
  collapseAll: "m8 1 4 4 4-4M8 23l4-4 4-4M4 12h16",
  grid: "M4 4h7v7H4zM13 4h7v7h-7zM4 13h7v7H4zM13 13h7v7h-7z",
  filter: "M3 5h18l-7 8v6l-4 2v-8L3 5z",
  home: "M3 11 12 3l9 8M5 10v10h14V10",
  calendar: "M4 6h16v15H4zM4 10h16M8 3v4M16 3v4",
  json: "M8 4c-3 0-3 3-3 4s0 4-3 4c3 0 3 3 3 4s0 4 3 4M16 4c3 0 3 3 3 4s0 4 3 4c-3 0-3 3-3 4s0 4-3 4",
  text: "M4 6h16M4 12h10M4 18h7",
  toggle: "M7 7h10a5 5 0 0 1 0 10H7A5 5 0 0 1 7 7zM7 9.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5z",
  sort: "M8 4v16l-4-4M16 20V4l4 4",
  sortAsc: "M12 20V4l-5 5M12 4l5 5",
  sortDesc: "M12 4v16l-5-5M12 20l5-5",
  pageFirst: "m11 7-5 5 5 5M18 7l-5 5 5 5",
  pageLast: "m13 7 5 5-5 5M6 7l5 5-5 5",
  drag: "M8 6h8M8 12h8M8 18h8",
  tiles: "M3 3h8v8H3zM13 3h8v8h-8zM3 13h8v8H3zM13 13h8v8h-8z",
  folder: "M3 6h6l2 2h10v11H3z",
  dot: "M12 10a2 2 0 1 0 0 4 2 2 0 0 0 0-4z",
  menu: "M4 7h16M4 12h16M4 17h16",
  users: "M9 4.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7zM2 20c0-4 3-6 7-6s7 2 7 6M16 4.5a3.5 3.5 0 0 1 0 7M22 20c0-3-1.5-5-4-5.5",
  database: "M4 5c0 1.7 3.6 3 8 3s8-1.3 8-3-3.6-3-8-3-8 1.3-8 3zM4 5v14c0 1.7 3.6 3 8 3s8-1.3 8-3V5M4 12c0 1.7 3.6 3 8 3s8-1.3 8-3",
  login: "M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4M10 17l5-5-5-5M15 12H3",
  logout: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9",
  dock: "M3 4h18v16H3zM15 4v16"
} as const;

export type IconName = keyof typeof iconPaths;

export const iconNames = Object.keys(iconPaths) as IconName[];

type IconProps = Omit<SVGProps<SVGSVGElement>, "name"> & { name: IconName; size?: number };

const filled: Partial<Record<IconName, boolean>> = { play: true, pin: true, dot: true };

export function Icon({ name, size, className, ...rest }: IconProps) {
  const path = iconPaths[name];
  const fill = filled[name] === true ? "currentColor" : "none";
  const style = size === undefined ? rest.style : { ...rest.style, width: size, height: size };

  return (
    <svg
      {...rest}
      style={style}
      className={["fxmap-icon", className].filter(Boolean).join(" ")}
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
      fill={fill}
      stroke="currentColor"
      strokeWidth={name === "more" ? 3 : 2}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d={path} />
    </svg>
  );
}
